__webpack_require__.p = "/react-lotto-generator/";